import { SnackbarKey, SnackbarMessage } from 'notistack';

import RetryButton from '@components/RetryButton/RetryButton';
import ToastCloseButton from '@components/ToastCloseButton/ToastCloseButton';
import { enqueueSnackbar } from '@store/features/notifications/slice';
import store from '@store/store';

const handleRetryToast = (
  message: SnackbarMessage,
  onClick: (snackbarId: SnackbarKey) => void,
): void => {
  store.dispatch(
    enqueueSnackbar({
      message,
      options: {
        key: new Date().getTime() + Math.random(),
        variant: 'info',
        action: snackbarId => (
          <>
            <RetryButton onClick={() => onClick(snackbarId)} />
            <ToastCloseButton toastKey={snackbarId} />
          </>
        ),
        autoHideDuration: null,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      },
    }),
  );
};

export default handleRetryToast;
